import { render, staticRenderFns } from "./RectArea.vue?vue&type=template&id=7f06e0ea&"
import script from "./RectArea.vue?vue&type=script&lang=js&"
export * from "./RectArea.vue?vue&type=script&lang=js&"
import style0 from "./RectArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports